import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Route wrapper that syncs i18n language from the URL prefix.
 * For default (Italian) routes without prefix, pass explicit lang="it".
 */
const LangRoute = ({ lang: explicitLang }) => {
  const { i18n } = useTranslation();
  const params = useParams();
  const lang = explicitLang || params.lang || "it";

  useEffect(() => {
    if (lang && i18n.language !== lang && ["it", "en", "ja"].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return <Outlet />;
};

export default LangRoute;
